import * as React from 'react';
import {FunctionComponent, useRef, useState} from 'react';
import {Overlay, Tooltip} from 'react-bootstrap';
import {classNames} from '../../Support/classNames';

interface OwnProps {
    description: string;
    className?: string;
}

export const InfoTooltip: FunctionComponent<OwnProps> = ({description, className}) => {
    const [show, setShow] = useState(false);
    const target = useRef(null);

    return (
        <>
            <button
                ref={target}
                className={classNames('btn btn-infotooltip', className)}
                onClick={() => setShow(!show)}
                onMouseOver={() => setShow(true)}
                onMouseLeave={() => setShow(false)}
            >
                <i className="bi bi-info-circle" />
            </button>
            <Overlay target={target.current} show={show} placement="right">
                {(props) => <Tooltip {...props}>{description}</Tooltip>}
            </Overlay>
        </>
    );
};
